export default __webpack_public_path__ + "static/screenshot-0e38dd8234529672e168b63787c7e41f.png";